module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS1.8768a200.jpg";